'use es6';

import { useEffect, useRef } from 'react';
export default function usePrevious(value) {
  const ref = useRef(value);
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}